<stages-dialog2 #dialog>
	<stages-popup-header [viewedDialog]="dialogViewedChild"></stages-popup-header>
	<stages-popup-content>
		<stages-page-header [headline]="headline" [backButtonDisabled]="true"></stages-page-header>

		<stages-grouped-data-view
			listStyles="grouped-list dense"
			[dataSource]="$any(dataSourceProcess)"
			[groupTemplate]="groupItemTemplate"
			[listItemTemplate]="listViewProcess"
			[tableItemTemplate]="listViewProcess"
			[idFn]="processReleaseDetailsComponent.getApprovementId"
			[groupIdFn]="$any(processReleaseDetailsComponent.getGroupId)"
			[groupDisabledFn]="$any(false)"
			[pageSize]="pageSize"
			[collapsibleGroupName]="processReleaseDetailsComponent.collapsibleGroupNameProcess"
			translateNone="process.releasedetails.empty"
		>
		</stages-grouped-data-view>

		<h5 class="headline" translate="process.releasedetails.card.modules"></h5>

		<stages-grouped-data-view
			listStyles="grouped-list dense"
			[dataSource]="$any(dataSourceModules)"
			[groupTemplate]="groupItemTemplate"
			[listItemTemplate]="listViewProcess"
			[tableItemTemplate]="listViewProcess"
			[idFn]="processReleaseDetailsComponent.getApprovementId"
			[groupIdFn]="$any(processReleaseDetailsComponent.getGroupId)"
			[groupDisabledFn]="$any(false)"
			[collapsibleGroupName]="processReleaseDetailsComponent.collapsibleGroupName"
			[pageSize]="pageSize"
			translateNone="process.releasemodules.empty"
		>
		</stages-grouped-data-view>
	</stages-popup-content>
	<stages-popup-footer *ngIf="dialogViewedChild" [viewedDialog]="dialogViewedChild"></stages-popup-footer>
</stages-dialog2>

<ng-template #groupItemTemplate let-entry>
	<div class="label">
		<a *ngIf="hasReadPermission(entry.actions)" [routerLink]="openProcess(entry)" target="_blank">
			<ng-content *ngTemplateOutlet="groupTitle; context: { $implicit: entry }"></ng-content>
		</a>
		<ng-container *ngIf="!hasReadPermission(entry.actions)">
			<ng-content *ngTemplateOutlet="groupTitle; context: { $implicit: entry }"></ng-content>
		</ng-container>
	</div>
</ng-template>

<ng-template #groupTitle let-entry>
	<h3>
		{{
			entry.processVersionName !== null
				? entry.workspaceName + " (" + entry.processVersionName + ")"
				: entry.workspaceName
		}}
	</h3>
</ng-template>

<ng-template #listView let-item>
	<ng-container *ngIf="item && item.items && item.items.length > 0">
		<ng-container *ngFor="let approvement of item.items">
			<li class="list-item">
				<stages-list-item-profile-and-comment-template
					[userName]="approvement.participantName"
					[userNameSubdetail]="approvement.userName"
					[userId]="approvement.userId"
					[userEmail]="approvement.emailAddress"
					[userProfileVersion]="approvement.userProfileVersion"
					[date]="approvement.creationDate"
					[subDetail]="approvement.transitionName"
					[subDetail2]="approvement.newState"
					[subDetailColor2]="approvement.newStateColor"
					[useColonDelimiter]="true"
				>
				</stages-list-item-profile-and-comment-template>
			</li>
		</ng-container>
	</ng-container>
	<ng-container *ngIf="item && item.items && item.items.length <= 0">
		<ng-container *ngTemplateOutlet="emptyAutomationDetails"></ng-container>
	</ng-container>
</ng-template>

<ng-template #listViewProcess let-item>
	<ng-container *ngIf="item">
		<ng-container
			*ngIf="item.processVersionDecription && item.processVersionDecription.html; else emptyVersionDescription"
		>
			<li class="list-item">
				<stages-description-view
					descriptionClass="inline"
					[html]="item.processVersionDecription.html"
				></stages-description-view>
			</li>
		</ng-container>
		<ng-container *ngTemplateOutlet="listView; context: { $implicit: item }"></ng-container>
	</ng-container>
</ng-template>

<ng-template #emptyVersionDescription>
	<li class="list-item">
		<div class="label">
			<div class="text center">
				<p class="notice" [translate]="'process.releasedetails.versiondescription.empty'"></p>
			</div>
		</div>
	</li>
</ng-template>

<ng-template #emptyAutomationDetails>
	<li class="list-item">
		<div class="label">
			<div class="text center">
				<p class="notice" [translate]="'process.releasedetails.automationdetails.empty'"></p>
			</div>
		</div>
	</li>
</ng-template>
